import { Component, OnInit, ViewChild } from '@angular/core';
import { HeaderComponent } from './navigation/header/header.component';
import {JwtHelperService} from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { AuthService } from './_service/auth.service';
import { AlertifyService } from './_service/alertify.service';
import { SearchComponent } from './search/search.component';
import { buildSearchQueryParams, parseSearchQueryParams } from './search/search-url-params';
import { AnalyticsService } from './_service/analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  
  title = 'SDS PHSA';
  openSidenav = false;
  windowsAuthResponse: any;

  jwtHelper = new JwtHelperService();

  constructor(
    private authService: AuthService,
    private router: Router,
    private alertify: AlertifyService,
    private analyticsService: AnalyticsService
    ) {}

  @ViewChild(HeaderComponent, { static: true }) header: HeaderComponent;

  onActivate(componentRef) {
    if (componentRef instanceof SearchComponent) {
      this.header.isSearchBoxHidden = false;
      this.syncHeaderWithSearchComponent(componentRef);
    } else {
      this.header.isSearchBoxHidden = true;
    }

    this.setupHeaderChangeEvent(componentRef);
    this.setupLoadingStateHandler(componentRef);
  }

  private syncHeaderWithSearchComponent(searchComponent: SearchComponent) {
    this.header.refreshSearchState();

    if (this.header.selectedSearchParameter) {
      searchComponent.selectedParameter = this.header.selectedSearchParameter;
      searchComponent.selectedSearchParameter = this.header.selectedSearchParameter;

      setTimeout(() => {
        searchComponent.setControlState();
      });
    }

    this.applySearchStateFromUrl(searchComponent);
  }

  private initialSearchActivationHandled = false;

  private applySearchStateFromUrl(searchComponent: SearchComponent) {
    const queryParams = this.router.parseUrl(this.router.url).queryParams;
    const restored = parseSearchQueryParams(queryParams);
    const isColdLoad = !this.initialSearchActivationHandled;
    this.initialSearchActivationHandled = true;
    if (!restored) {
      return;
    }

    if (isColdLoad && this.isPageReload()) {
      this.router.navigate(['/search'], { replaceUrl: true });
      return;
    }

    const internalParameter = restored.internalParameter;
    const value = restored.value;

    setTimeout(() => {
      this.header.selectedParameter = internalParameter;
      this.header.selectedSearchParameter = internalParameter;
      this.header.value = value;
      this.header.searchBarForm.controls['searchStringControl'].setValue(value);
      this.header.refreshSearchState();

      searchComponent.selectedParameter = internalParameter;
      searchComponent.selectedSearchParameter = internalParameter;
      searchComponent.setControlState();
      searchComponent.searchForProducts(value);
    });
  }

  // Distinguishes an F5/reload from a pasted link or bookmark navigation.
  private isPageReload(): boolean {
    const getEntries = performance.getEntriesByType && performance.getEntriesByType('navigation');
    if (getEntries && getEntries.length) {
      return (getEntries[0] as any).type === 'reload';
    }
    // IE11 fallback (deprecated Navigation Timing Level 1 API)
    return !!(performance.navigation && performance.navigation.type === 1);
  }

  private setupHeaderChangeEvent(componentRef) {
    this.header.changeEvent = (selectedParm, selectedValue) => {
      const params = buildSearchQueryParams(selectedParm, selectedValue);

      if (componentRef.searchForProducts != null) {
        componentRef.selectedSearchParameter = selectedParm;
        componentRef.selectedParameter = selectedParm;
        
        if (componentRef.setControlState) {
          componentRef.setControlState();
        }
        
        componentRef.searchForProducts(selectedValue);
        this.router.navigate(['/search'], { queryParams: params });
      } else {
        this.router.navigate(['/search'], { queryParams: params });
      }
    };
  }

  private setupLoadingStateHandler(componentRef) {
    if (componentRef.setLoadingState != null) {
      componentRef.setLoadingState = (isLoading) => {
        this.header.isLoading = isLoading;
      };
    }
  }

  ngOnChanges() {}

  ngOnInit() {
    const token = localStorage.getItem('token');
    if (token) {
      this.authService.decodedToken = this.jwtHelper.decodeToken(token);
    }
  }

  logout() {
    this.authService.logout();
    this.alertify.message('Logged out Successfully');
    this.router.navigate(['/search']);
  }
}